import ko from "knockout";
ko.bindingHandlers.placeholder = {
    init: function (element, valueAccessor) {
        const underlyingObservable = valueAccessor();
        ko.applyBindingsToNode(element, {
            attr: { placeholder: underlyingObservable },
        });
    },
};
